// src/hooks/useProgram.js
import { useState, useEffect } from 'react';
import { doc, onSnapshot } from 'firebase/firestore';
import { db } from '@/firebase/firebase';

/**
 * Real-time listener for a single program document.
 *
 * @param {string|null} programId
 * @returns {{ program: Object|null, loading: boolean, error: Error|null }}
 */
export default function useProgram(programId) {
  const [program, setProgram] = useState(null);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);

  useEffect(() => {
    if (!programId) {
      setProgram(null);
      setLoading(false);
      return;
    }

    setLoading(true);

    const unsub = onSnapshot(
      doc(db, 'programs', programId),
      (snap) => {
        setProgram(snap.exists() ? { id: snap.id, ...snap.data() } : null);
        setError(null);
        setLoading(false);
      },
      (err) => {
        console.error('[useProgram]', err);
        setError(err);
        setLoading(false);
      }
    );

    return unsub;
  }, [programId]);

  return { program, loading, error };
}
